import { sendGetRequest, sendGetRequestWithFullResponse, sendPutRequest } from '@/services/api.service'
import { API_REVIEW } from '@/config/api.config'

export const getReviewFormsApi = (clientId, locale) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms`, { headers: { locale: locale } })
}

export const getFormReviewApi = (clientId, formId, urlParams, filterParams) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/reviews?${urlParams}${filterParams}`)
}

export const getFormApi = (clientId, formId) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}`)
}
export const getFormFieldsApi = (clientId, formId) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/${API_REVIEW.FORMS}/${formId}/fields`)
}
export const setFormFieldsApi = (clientId, formId, fields) => {
  return sendPutRequest(`${API_REVIEW.BASE_API_URL}${clientId}/${API_REVIEW.FORMS}/${formId}/fields`, fields)
}
export const getReviewApi = (clientId, formId, reviewId) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/reviews/${reviewId}`)
}

export const getPublicUserReview = reviewToken => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}/reviewTokens/${reviewToken}/viewReview`)
}
export const updateReviewToken = (reviewToken, reviewUpdated) => {
  return sendPutRequest(`${API_REVIEW.BASE_API_URL}/reviewTokens/${reviewToken}/updateReview`, reviewUpdated)
}

export const getReviewsFiltersApi = (clientId, formId) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/reviews/fetchFilters`)
}

export const getReviewExportApi = (clientId, formId, urlParams, filterParams) => {
  return sendGetRequestWithFullResponse(
    `${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/reviews/export?${urlParams}${filterParams}`,
    {
      headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
      responseType: 'arraybuffer',
    }
  )
}
export const getFormStaticsApi = (clientId, formId) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/${API_REVIEW.FORMS}/${formId}/statics`)
}
export const setFormStaticsApi = (clientId, formId, statics) => {
  return sendPutRequest(`${API_REVIEW.BASE_API_URL}${clientId}/${API_REVIEW.FORMS}/${formId}/statics`, statics)
}

export const getFormDefaultTranslations = clientId =>
  sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/defaultTranslations`)

export const getLastWidgetVersion = async () => {
  var url = 'https://gtr-review-widget.s3.eu-west-3.amazonaws.com/latest/version.json'
  if (process.env.BO_ENV !== 'production') {
    url = `https://gtr-review-widget-preprod.s3.eu-west-3.amazonaws.com/latest/version.json`
  }
  try {
    const versionJson = await sendGetRequest(url)
    return versionJson.version ? versionJson.version : 'latest'
  } catch (error) {
    return 'latest'
  }
}

export const putFormSettingsApi = (clientId, formId, settings) => {
  return sendPutRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/settings`, settings)
}

export const putFormTranslationsApi = (clientId, formId, translations) => {
  return sendPutRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/translations`, translations)
}

export const getConditionableFieldsApi = (clientId, locale, formId) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/conditionableFields`, {
    headers: { locale: locale },
  })
}
export const getFormSubmissionApi = (clientId, formId, reviewId) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/formSubmissions/${reviewId}`)
}

export const getFormReviewsApi = (clientId, formId, urlParams, filterParams) => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}${clientId}/forms/${formId}/reviews?${urlParams}${filterParams}`)
}
export const getClientReviewsApi = clientId => {
  return sendGetRequest(`${API_REVIEW.BASE_API_URL}/clients/${clientId}`)
}
export const putClientQuestionBank = (clientId, questionBank) => {
  return sendPutRequest(`${API_REVIEW.BASE_API_URL}/clients/${clientId}/questionBank`, { questions: questionBank })
}

export const putClientNotifications = (clientId, notifications) => {
  return sendPutRequest(`${API_REVIEW.BASE_API_URL}/clients/${clientId}/notifications`, notifications)
}
